import {db} from './index';
import {collection, getDocs, orderBy, query, limit} from 'firebase/firestore';
import {snapShotToArray} from './common';

const testimonialsCollection = collection(db, 'meta-testimonials');

export const getAllTestimonials = async () => {
  const array = snapShotToArray(await getDocs(query(testimonialsCollection, orderBy('date', 'desc'))));
  return array.map(value => {
    const {updatedAt, createdAt, ...other} = value;
    return other;
  });
};

export const getTopTestimonials = async (limitCount) => {
  const array = snapShotToArray(await getDocs(query(testimonialsCollection, orderBy('date', 'desc'), limit(limitCount))));
  return array.map(value => {
    const {updatedAt, createdAt, ...other} = value;
    return other;
  });
};
